// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"e1fef05c","151":"49cadd59","215":"3bf11045","683":"e1fef05c"}[chunkId] + ".chunk.css";
};